import { Image } from "primereact/image";

// One part of the detail of a checklist row (problem lama / pergi / pulang): a small photo on the left,
// the label and the note next to it. The photo opens big on tap (preview).
const ChecklistRowDetail = ({
  label,
  labelClassName = "text-slate-400",
  noteClassName = "text-gray-500",
  className = "",
  note,
  gambar,
  alt,
}) => (
  <div className={`row-start-start w-full gap-2 ${className}`}>
    {gambar && (
      <Image
        className="shrink-0 bg-white shadow-sm"
        src={gambar}
        alt={alt}
        width="56"
        preview
      />
    )}
    <div className="col-start-start gap-0.5 min-w-0">
      {label && (
        <span className={`text-xs font-semibold ${labelClassName}`}>
          {label}
        </span>
      )}
      {note && note.length > 0 && (
        <span className={`text-xs italic break-words ${noteClassName}`}>
          {note}
        </span>
      )}
    </div>
  </div>
);

export default ChecklistRowDetail;
